import React, { Component, ReactNode } from 'react';
import { FormicaProps, withFormica } from '../../helpers/withFormica';
import { dispatch, RootState, store } from '../../redux/store';
import { PagePath, PageState } from '../../redux/reducers/PageReducer';
import { DefaultFilter, UserSystemAttributes } from '../../domain/rbac/RbacDomains';
import { ComponentState, setSelectedItems } from '../../redux/actions/ComponentActions';
import { CaseState } from '../../redux/reducers/CaseReducer';
import { connect } from 'react-redux';
import { changePageFilter, clearPage } from '../../redux/actions/PageActions';
import { changeCaseColumns, changeContainerLoading } from '../../redux/actions/CaseActions';
import { setAttribute } from '../../redux/actions/UserActions';
import { ConnectedProps } from 'react-redux/es/exports';
import Breadcrumb from '../../components/Breadcrumb';
import { ConfirmPopup } from 'primereact/confirmpopup';
import Icon from '../../icons/Icon';
import LanguageUtil from '../../util/LanguageUtil';
import CustomTabv3, { CustomTabItemProps } from '../../components/custom/CustomTabv3';
import ValueUtil from '../../util/ValueUtil';
import { CaseSettings } from '../../domain/case/CaseDomains';
import { query, repository, subscribe } from '@trlogic/client-js';
import CollectionNames from '../../constant/CollectionNames';
import { InstanceContainer } from '../../config/binding/InstanceBinding';
import Injectables from '../../constant/Injectables';
import CaseService from '../../service/CaseService';
import ServiceContainer from '../../config/ServiceContainer';
import { ServiceNames } from '../../constant/ServiceNames';
import CustomBadge from '../../components/custom/CustomBadge';
import TransactionItemToolsMenu from './TransactionItemToolsMenu';
import _ from 'lodash';
import TransactionListComponent from './TransactionListComponent';
import ComponentName from '../../constant/ComponentName';
import FolderService from '../../service/FolderService';
import { CustomFilter, CustomFilterField, CustomFilterFields } from '../../domain/ui/FilterDomains';
import FilterUtil from '../../util/FilterUtil';
import DefaultFilterUtil from '../../util/DefaultFilterUtil';
import DataType from '../../constant/DataType';
import ValueFactory from '../../util/ValueFactory';
import CustomSkeleton from '../../components/custom/CustomSkeleton';
import IntervalManager from '../../util/IntervalManager';
import NavigationUtil from '../../util/NavigationUtil';
import QueryBuilder = query.QueryBuilder;
import eq = query.eq;
import Filter = query.Filter;
import empty = query.empty;
import Order = query.Order;

class TransactionContainer extends Component<Props, State> {
  public state: State = new State();

  private caseSettingsSubscription: subscribe.Subscription | undefined;
  private currentCaseSettingsSubscription: subscribe.Subscription | undefined;
  private channelSubscription: subscribe.Subscription | undefined;
  private chatSubscription: subscribe.Subscription | undefined;
  private computation: subscribe.Computation | undefined;

  private readonly repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);
  private readonly transactionService: CaseService = ServiceContainer.getInstance().get(ServiceNames.CASE);
  private readonly intervalManager: IntervalManager = InstanceContainer.get(Injectables.INTERVAL_MANAGER);

  public render() {
    const { currentCaseSettings, loading, filterLoading, updates, totalRecord, filter, settings, rows, currentPage, sort } = this.state;
    return (
      <div className='w-full h-full flex flex-col overflow-y-hidden'>
        <Breadcrumb />
        <ConfirmPopup />
        <div className={'flex w-full shrink-0 px-5 pt-5 gap-x-5 overflow-x-hidden'}>
          <div key={'case-icon'} className='w-[80px] shrink-0 h-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE]'>
            <Icon icon={'case'} size={30} className={'hidden'} color={'#728EFF'} />
          </div>
          <div className={'flex flex-col gap-y-1 overflow-x-scroll'}>
            <span className={'text-4xl text-black font-normal'}>{LanguageUtil.get({ id: `common.label.case`, defaultMessage: 'Case' })} Page</span>
            <CustomTabv3
              tab={this.getTabItems()}
              onClick={(e: any, tab: string) => this.onChangeDomain(tab)}
              selectedTab={currentCaseSettings?.id ?? '__all__'}
            />
          </div>
        </div>
        <div className={'flex justify-between bg-white items-center w-full px-5'}>
          <TransactionItemToolsMenu
            currentCaseSettings={currentCaseSettings}
            loading={filterLoading}
            caseSettings={settings}
            totalRecord={totalRecord}
            onChangeFilter={this.onChangeFilter}
            filter={filter}
            rows={rows}
            currentPage={currentPage}
            sorts={sort}
          />
        </div>
        <div className={'px-5 h-full'}>
          {!loading ? (
            <TransactionListComponent
              key={updates[currentCaseSettings?.name ?? '__all__']}
              currentCaseSettings={currentCaseSettings}
              caseSettings={settings}
              filter={filter}
              onFetchCount={(value: number) => this.setState({ totalRecord: value })}
              onChangeFilter={this.onChangeFilter}
              onTablePropChange={(sort: Order[], rows: number, currentPage: number) => {
                this.setState({ sort, rows, currentPage });
              }}
            />
          ) : (
            <CustomSkeleton />
          )}
        </div>
      </div>
    );
  }

  public componentDidMount = async () => {
    const {
      router: { params },
    } = this.props;
    this.intervalManager.clearTransactionIntervals();
    this.intervalManager.clearTransactionCountIntervals();
    if (params.domain) {
      await this.onChangeDomain(params.domain);
    } else {
      await this.onChangeDomain('__all__');
    }
    this.handleTransactionCounts();
  };

  public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (
      prevProps.page.currentCategory != undefined &&
      this.props.page.currentCategory &&
      prevProps.page.currentCategory?.id !== this.props.page.currentCategory?.id
    ) {
      const path: PagePath | undefined = this.props.page.pagePath[this.props.page.activePageIndex];
      if (path && this.state.currentCaseSettings?.name != path.title) {
        this.onChangeDomain(path.payload.path.length == 1 ? '__all__' : path.title);
      }
    }
  }

  public componentWillUnmount = async () => {
    this.intervalManager.clearTransactionIntervals();
    this.props.clearPage();
    this.props.changeCaseColumns({});
    await this.stopTracker();
  };

  private startTracker = () => {
    const transactionSettingsName = this.getCaseSettingsId();
    const caseSettingsQuery = QueryBuilder.select().from(CollectionNames.CASE_SETTINGS).select('name', 'dataSource', 'keyField').build();
    this.caseSettingsSubscription = subscribe.Formica.subscribe(CollectionNames.CASE_SETTINGS, caseSettingsQuery);
    this.subscribeToChats();
    this.computation = subscribe.Tracker.autorun(this.tracker, [this.caseSettingsSubscription]);
    if (transactionSettingsName != '__all__') {
      const currentTransactionSettingsQuery = QueryBuilder.select().from(CollectionNames.CASE_SETTINGS).where(eq('id', transactionSettingsName)).build();
      this.currentCaseSettingsSubscription = subscribe.Formica.subscribe(CollectionNames.CASE_SETTINGS, currentTransactionSettingsQuery);
      this.computation.addSubscription(this.currentCaseSettingsSubscription);
    }
  };

  private stopTracker = async () => {
    this.currentCaseSettingsSubscription?.stop();
    this.caseSettingsSubscription?.stop();
    this.channelSubscription?.stop();
    this.channelSubscription = undefined;
    this.chatSubscription?.stop();
    this.chatSubscription = undefined;
    this.computation?.stop();
  };

  private tracker = async () => {
    const transactionSettingsName = this.getCaseSettingsId();
    if (this.caseSettingsSubscription?.ready() && (transactionSettingsName != '__all__' ? this.currentCaseSettingsSubscription?.ready() : true)) {
      await this.buildData();
    }
  };

  private resubscribeTracker = async () => {
    if (this.computation == undefined) {
      this.startTracker();
      return;
    }
    this.computation?.onStop(() => {
      this.startTracker();
    });
    await this.stopTracker();
  };

  private buildData = async () => {
    const transactionSettingsName = this.getCaseSettingsId();
    let currentCaseSettings: CaseSettings | undefined = undefined;
    if (transactionSettingsName != '__all__') {
      const currentTransactionSettingsQuery = QueryBuilder.select().from(CollectionNames.CASE_SETTINGS).where(eq('id', transactionSettingsName)).build();
      currentCaseSettings = await this.repository.find<CaseSettings>(currentTransactionSettingsQuery);
      this.trySubscribeToChannel(currentCaseSettings);
    }
    const allSettings = await this.repository.findMany<CaseSettings>(QueryBuilder.select().from(CollectionNames.CASE_SETTINGS).build());
    this.setState({ currentCaseSettings, settings: allSettings, loading: false }, () => {
      this.props.changeContainerLoading(false);
      this.getFilterFields(true);
    });
  };

  private onChangeDomain = async (domain: string) => {
    const {
      router: { navigate, location },
      changeCaseColumns,
    } = this.props;
    const { updates } = this.state;
    this.setState({ loading: true, filterLoading: true }, async () => {
      this.props.changeContainerLoading(true);
      changeCaseColumns({});
      if (domain == '__all__') {
        navigate(`/cases`, { replace: true });
        await FolderService.calculateCase(location.pathname);
        await this.prepareFilterFields();
      } else {
        if (`/cases/${domain}` != location.pathname) {
          navigate(`/cases/${domain}`, { replace: true });
        }
        await FolderService.calculateCase(location.pathname, domain);
        await this.prepareFilterFields();
      }
      dispatch(setSelectedItems([]));
      updates[domain] = (updates[domain] ?? 0) + 1;
      this.setState({ updates }, this.resubscribeTracker);
    });
  };

  private prepareFilterFields = async () => {
    const {
      changePageFilter,
      attributes,
      user,
      router: { params },
    } = this.props;
    const domain = params.domain || 'All';
    let filter = ValueFactory.initializeFilter();
    if (domain) {
      const defaultFilter: DefaultFilter | undefined = _.cloneDeep(
        DefaultFilterUtil.find(attributes.filters, {
          component: ComponentName.CASE,
          id: domain,
          riskType: user!.activeRiskType,
        }),
      );
      if (defaultFilter) {
        filter = defaultFilter.filter.filter;
      }
    }
    const fields: CustomFilterFields[] = await FilterUtil.getFields(ComponentName.CASE);
    changePageFilter({
      filter: filter,
      items: fields,
    });
    this.setState({ filter: FilterUtil.parse(filter), filterLoading: false });
  };

  private getCaseSettingsId = () => {
    const {
      router: {
        params: { domain: alarmDomainType },
      },
    } = this.props;
    return alarmDomainType || '__all__';
  };

  private getTabItems = (): CustomTabItemProps[] => {
    const { settings, transactionCounts } = this.state;
    const {
      case: { transactionContainerLoading, transactionListComponentLoading, transactionListDataLoading, transactionCountLoading },
    } = this.props;
    const items: CustomTabItemProps[] = [];
    const totalCount = Object.entries(transactionCounts).reduce((acc, [key, value]) => acc + value, 0) || 0;
    const shortenedTotalCount = ValueUtil.numberShorten(totalCount);
    items.push({
      key: '__all__',
      label:
        totalCount > 0 ? (
          <span className='flex gap-[4px]'>
            {LanguageUtil.get({ id: 'common.label.all', defaultMessage: 'All' })}
            <CustomBadge value={shortenedTotalCount} color='#458EF7' />
          </span>
        ) : (
          LanguageUtil.get({ id: 'common.label.all', defaultMessage: 'All' })
        ),
      disabled: transactionContainerLoading || transactionListComponentLoading || transactionListDataLoading,
      testid: `${ComponentName.CASE}___all___tab`,
    });
    for (const setting of settings.map((s) => s.name).sort(this.customSort)) {
      let label: string | ReactNode = setting;
      const count = transactionCounts[setting] || 0;
      if (count > 0) {
        const shortened = ValueUtil.numberShorten(count);
        label = (
          <span className='flex gap-[4px]'>
            {setting}
            <CustomBadge value={shortened} color='#458EF7' />
          </span>
        );
      }
      items.push({
        key: setting,
        label: label,
        disabled: transactionContainerLoading || transactionListComponentLoading || transactionListDataLoading,
        testid: `${ComponentName.CASE}_${setting}_tab`,
      });
    }
    return items;
  };

  private handleTransactionCounts = () => {
    this.onHandleTransactionCounts();
    this.intervalManager.addTransactionCountInterval(
      setInterval(async () => {
        await this.onHandleTransactionCounts();
      }, 10_000) as any,
    );
  };

  private onHandleTransactionCounts = async () => {
    try {
      const counts = await this.transactionService.getCounts();
      this.setState({ transactionCounts: counts });
    } catch (e) {
      console.error(e);
    }
  };

  private onChangeFilter = (filter: Filter) => {
    if (_.isEqual(filter, this.state.filter)) return;
    this.setState({ filter }, this.incrementCurrent);
  };

  private incrementCurrent = () => {
    const { updates, currentCaseSettings } = this.state;
    updates[currentCaseSettings?.name ?? '__all__'] = (updates[currentCaseSettings?.name ?? '__all__'] ?? 0) + 1;
    this.setState({ updates });
  };

  private getFilterFields = async (saveFilter: boolean = false) => {
    const { currentCaseSettings } = this.state;
    const { changePageFilter, attributes, user } = this.props;
    const { page } = store.getState();
    const urlFilter = this.handleUrlFilter();
    const defaultFilter: DefaultFilter | undefined = DefaultFilterUtil.find(attributes.filters, {
      component: ComponentName.CASE,
      id: currentCaseSettings?.name,
      riskType: user!.activeRiskType,
    });
    if (urlFilter) {
      changePageFilter({
        filter: {
          type: 'ALL_MATCH',
          fields: urlFilter,
        } as CustomFilter,
        items: [],
      });
    } else if (currentCaseSettings != undefined && defaultFilter) {
      const newFilter = defaultFilter.filter.filter.fields.filter(
        (field: any) => !page.filter.filter.fields.some((pageField: any) => pageField.field == field.field),
      );
      if (newFilter.length > 0) {
        page.filter.filter.fields.push(...newFilter);
        changePageFilter({
          filter: page.filter.filter,
          items: [],
        });
      }
    }
    return FilterUtil.getCaseFields(currentCaseSettings?.dataSource, saveFilter);
  };

  private handleUrlFilter = (): CustomFilterField[] | undefined => {
    const {
      router: { location },
      changePageFilter,
      page,
    } = this.props;
    const params = new URLSearchParams(location.search);
    const filter = params.get('filters');
    if (filter) {
      try {
        const filters: { field: string; value: string; operator: string; dataType: DataType }[] = JSON.parse(filter);
        if (filters) {
          return filters.map((f) => {
            return {
              field: `variables.${f.field}.keyword`,
              label: f.field,
              enabled: true,
              search: {
                type: 'LITERAL',
                value: {
                  operator: f.operator,
                  properties: {
                    dataType: f.dataType,
                  },
                  value: f.value,
                },
              },
            };
          });
        }
        return undefined;
      } catch (e) {}
    }
  };

  private subscribeToChats = () => {
    const transactionSettingsName = this.getCaseSettingsId();
    if (this.chatSubscription != undefined || transactionSettingsName == '__all__') return;
    const chatQuery = query.QueryBuilder.select()
      .where(eq('domain', transactionSettingsName))
      .limit(200)
      .orderBy({
        field: 'timestamp',
        operator: 'ASC',
      })
      .build();
    this.chatSubscription = subscribe.Formica.subscribe(`transaction_chat_log_${NavigationUtil.getTenant()}`, chatQuery, undefined, 'elasticsearch');
  };

  private trySubscribeToChannel = (currentCaseSettings: CaseSettings | undefined) => {
    if (currentCaseSettings == undefined || this.channelSubscription != undefined) return;
    this.channelSubscription = subscribe.Formica.subscribe(
      CollectionNames.TRANSACTIONS,
      QueryBuilder.select().from(CollectionNames.TRANSACTIONS).where(eq('id', currentCaseSettings.dataSource)).build(),
    );
    this.computation?.addSubscription(this.channelSubscription);
  };

  private customSort = (a: string, b: string) => {
    const minLength = Math.min(a.length, b.length);
    for (let i = 0; i < minLength; i++) {
      const charA = a.charAt(i);
      const charB = b.charAt(i);
      if (charA !== charB) {
        return charA.localeCompare(charB);
      }
    }
    return a.length - b.length;
  };
}

interface Props extends FormicaProps, ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user,
  page: state.page as PageState,
  attributes: state.auth.attributes as UserSystemAttributes,
  component: state.component as ComponentState,
  case: state.case as CaseState,
});
const connector = connect(mapStateToProps, { clearPage, changePageFilter, changeCaseColumns, setAttribute, changeContainerLoading });
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  currentCaseSettings: CaseSettings | undefined;
  settings: Pick<CaseSettings, 'id' | 'name' | 'dataSource' | 'keyField'>[] = [];
  loading: boolean = true;
  totalRecord: number = 0;
  transactionCounts: Record<string, number> = {};
  reason: string | undefined;
  filter: Filter = empty();
  filterLoading: boolean = true;
  updates: Record<string, number> = {};

  sort: Order[] = [];
  rows: number = 10;
  currentPage: number = 1;
}

export default connector(withFormica(TransactionContainer));
